const GetApplicationMessagePayload = () => {

    return {
        "query": "query($preview:Boolean, $allowedLocale: [String], $appCode:String){applicationsCollection (preview:$preview, limit:1,where: {application3charCode:$appCode}){ items { linkedFrom (allowedLocales: $allowedLocale) { applicationResourcesCollection (limit:7000) { items{ key englishValue: value(locale: \"en-US\") frenchValue: value(locale: \"fr\") parseAsMarkdown } } } } }}",
        "variables": {
            "preview": false,
            "allowedLocale": [
                "en-US",
                "fr"
            ],
            "appCode": "QMA"
        }
    };

};

const GetProductTypesPayload = (userLanguage) => {

    const brand = process.env.REACT_APP_TOUR_OPERATOR;
    return {
        "query": "query($preview:Boolean, $locale:String, $brand: String) {tourOperatorCollection( preview: $preview locale: $locale limit: 2 where: { tourOperatorCode: $brand } ) {items {tourOperatorCode tourOperatorName linkedFrom(allowedLocales: [\"en-CA\", \"fr\"]) {qmaProductTypeCollection(preview:$preview,locale: $locale){items{productKey, productTypeName,productTypeInternalOnly}}}}}}",
        "variables": {
            "preview": false,
            "locale": (userLanguage === "en") ? "en-CA" : "fr",
            "brand": brand.toUpperCase()
        }
    };

};

const GetGroupTypesPayload = () => {
  
    return {
        "query": `query qmaGroupTypes ($preview: Boolean, $brandCode: String){
  groupTypes: qmaGroupTypeCollection(preview: $preview, where: { brand: { brandCode: $brandCode }}) {
    total
    items {
      groupTypeNameEn: groupTypeName(locale: "en-CA") 
	  groupTypeNameFr: groupTypeName(locale: "fr") 
      key
	events: qmaEventsCollection(preview: $preview, locale: "en-CA") {
		total
		items {
		  eventNameEn: eventName(locale: "en-CA")
		  eventNameFr: eventName(locale: "fr")
		  key
		}
      }
    }
  }
}`,
        "variables": {
            "preview": false,
            "brandCode": process.env.REACT_APP_BRAND.toUpperCase()
        }
    };

};

export const API_PARAMS = {
    GetGroupTypesPayload,
    GetProductTypesPayload,
    GetApplicationMessagePayload
};

export const ENDPOINTS = {
    QUOTE_PROCESSOR: {
        QUOTE_GET_ALL: "/quotes",
        QUOTE_GET: "/quote",
        QUOTE_ITINERARY: "/itinerary",
        DEVIATION_ITINERARY: "/itinerary/deviation",
        INVOICE_GENERATE: "/document/generateinvoice",
        INVOICE_SEND: "/document/sendinvoice",
        LEAD: "/lead",
        RE_QUOTE_GET: "/requote",
        UPDATE_ITINERARY: "/updateitinerary",
        CLONE_GET: "/clone",
        GROUP_CONTRACT: "/document/groupcontract",
        QUOTE_LETTER_EMAIL: "/document/quoteletter",
        QUOTE_LETTER_UPDATE: "/document/updatequoteletter",
        GROUP_CONTRACT_EMAIL: "/document/sendgroupcontract",
        CUSTOM_QUOTE_PDF_GET: "/document/customquoteletter",
        FLIGHTS: "/flights"
    },
    SEARCH_API: {
        DEPARTURE: "/gateway",
        DESTINATION: "/Destination/group",
        HOTEL: "/Hotels",
        ROOM: "/Hotels/Rooms",
        CABIN: "/Cruises/Rooms",
        FLIGHTS_DATES: "/offers/dates/flight"
    }
};
